export default {
  CHECKLIST_SURVEYS_FETCHED: 'CHECKLIST_SURVEYS_FETCHED',
  CHECKLIST_SURVEY_LOAD: 'CHECKLIST_SURVEY_LOAD',
  CHECKLIST_SURVEY_DETAIL: 'CHECKLIST_SURVEY_DETAIL',
  RESEARCH_TEMPLATES_FETCHED: 'RESEARCH_TEMPLATES_FETCHED',
  RESEARCH_TEMPLATES_LOAD: 'RESEARCH_TEMPLATES_LOAD',
  CHECKLIST_SURVEY_BUTTON_LOAD: 'CHECKLIST_SURVEY_BUTTON_LOAD',
};
